import React from 'react';
import styled from 'styled-components';
import {ReactComponent as LockIcon} from '../images/lock.svg';
import Button from '@atlaskit/button';
import {Trans} from 'react-i18next';

const Container = styled.div`
  display: flex;
  height: 80vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const Msg = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 26px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.154px;
  color: #172B4D;
  margin: 12px 0px;
  max-width:320px;
`

export default ({action}) => (
  <Container>
    <LockIcon/>
    <Msg>
      <Trans>
        You do not have permission to access this section
      </Trans>
    </Msg>
    {action && (
      <Button appearance='subtle' onClick={action}>
        <Trans>
          Change account
        </Trans>
      </Button>
    )}
  </Container>
)